function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailUnsubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 249.09 150.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 83") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.46,85.63l2.14-.37.61-.12a17.53,17.53,0,0,1,11.2-32.32l-2.8,6.66,6.63-5.79,0,0A17.53,17.53,0,0,1,198,76.07h0c-.11.32-.24.62-.37.92a21,21,0,0,0,5.13-3.44c3-2.84,4.59-6.76,6.41-11.59,3.6-9.57,7.06-19.29,10.39-29a17.53,17.53,0,0,1-8.19-21.22c.18-.51.38-1,.6-1.47l.17-.36c.22-.46.46-.91.71-1.34l.13-.21q.34-.55.71-1.06L214,6.9c.28-.37.57-.73.88-1.07l.32-.33q.35-.37.73-.73l.4-.37.1-.09h0a17.52,17.52,0,0,1,22.42-.5l-3.64,8.67,6.56-5.72a17.44,17.44,0,0,1,.65,20.65h0l-.23.3-.42.57c-.19.24-.38.47-.58.7s-.3.35-.45.51-.47.47-.7.7l-.42.4q-.57.51-1.17,1l-.43.3c-.28.2-.57.4-.86.58l-.56.32c-.27.15-.54.3-.82.44l-.59.28-.86.36-.59.22c-.33.12-.66.22-1,.31l-.5.15c-.5.13-1,.24-1.52.32l-.29,0c-.42.06-.85.11-1.28.14l-.56,0c-.35,0-.69,0-1,0l-.61,0q-.51,0-1-.09l-.6-.08c-.37-.06-.73-.13-1.1-.21h-.07q-2.11,6.16-4.29,12.29a17.52,17.52,0,0,1,24.75,1.31q.34.38.66.78l-6.06,6.7,8.21-3.28a17.47,17.47,0,0,1,.7,13.35,17.2,17.2,0,0,1-2.23,4.31,17.53,17.53,0,0,1-31.67-7.69l-.46,1.24c-1.6,4.26-3.6,9.57-7.6,13.4a30.74,30.74,0,0,1-9.26,5.64q-3.13,1.36-6.34,2.52a17.57,17.57,0,0,1-7.85,2.5c-3.38.94-6.8,1.72-10.25,2.33l-2.15.37c-1.94.33-3.92.67-5.89,1.07.28.08.57.16.85.26A17.54,17.54,0,0,1,177,108.83L163.46,113l12.22,1.94a17.54,17.54,0,0,1-29.23,5.19l.37,1.24c.25.82.49,1.64.73,2.45,3.21,11,1.83,19.73-3.9,24.46l-3.11-3.76c5.57-4.6,3.84-14.09,2.32-19.34-.23-.8-.47-1.6-.72-2.41-2.09-7-4.47-14.84-1.39-22.08C145.38,89.75,158.73,87.46,169.46,85.63Z",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.51,149.68H70.92A11.7,11.7,0,0,1,59.22,138h0V94.65a4.63,4.63,0,0,1,1.45-3.36l50.12-47.51a10.79,10.79,0,0,1,14.84,0l47.79,45.3a12.11,12.11,0,0,1,3.78,8.79V138a11.7,11.7,0,0,1-11.7,11.7Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.22,95.36h117v47.26a7.06,7.06,0,0,1-7.06,7.06H66.29a7.06,7.06,0,0,1-7.06-7.06h0V95.36Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1,92.53",
    style: {
      fill: "none",
      stroke: "#3f3d56",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,58.12h74.14a6.44,6.44,0,0,1,6.44,6.44V138.7a6.43,6.43,0,0,1-6.43,6.43H81a6.43,6.43,0,0,1-6.43-6.43V64.56A6.43,6.43,0,0,1,81,58.12Z",
    style: {
      fill: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.59 97.31 161.59 145.13 74.58 145.13 74.58 97.31 118.09 118.34 161.59 97.31",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.09,121,62.35,94.1a2.26,2.26,0,0,0-3.25,2v46.36a7.06,7.06,0,0,0,7.06,7.06H170a7.06,7.06,0,0,0,7.06-7.06h0V96.93a2.76,2.76,0,0,0-4-2.48Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.08,
    y: 66.11,
    width: 24.33,
    height: 3.44,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.11,
    y: 78.65,
    width: 72.26,
    height: 1.97,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.11,
    y: 85.28,
    width: 72.26,
    height: 1.97,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.11,
    y: 91.92,
    width: 72.26,
    height: 1.97,
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.98,
    y1: 149.55,
    x2: 217.51,
    y2: 149.55,
    style: {
      fill: "none",
      stroke: "#3f3d56",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,119.29c0,14.49,9.09,26.22,20.33,26.22",
    style: {
      fill: "#46455b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.33,145.51C20.33,130.85,30.47,119,43,119",
    style: {
      fill: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36,120.6c0,13.77,5.8,24.9,13,24.9",
    style: {
      fill: "#6c63ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.33,145.51c0-18.73,11.73-33.88,26.22-33.88",
    style: {
      fill: "#46455b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.05,145.69s2.88-.09,3.75-.71,4.43-1.36,4.65-.37,4.33,4.93,1.08,5-7.56-.51-8.43-1S16.05,145.69,16.05,145.69Z",
    style: {
      fill: "#a8a8a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.59,149.23c-3.25,0-7.56-.51-8.43-1-.66-.4-.92-1.85-1-2.51h-.1s.18,2.32,1,2.85,5.17,1.06,8.43,1c.94,0,1.26-.34,1.25-.84C26.64,149,26.29,149.23,25.59,149.23Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9,40c-.15,1.32-1.15,2.38-1.52,3.65-.56,1.91.41,4,1.73,5.46a12.08,12.08,0,0,0,8.41,4,3.59,3.59,0,0,0,1.39-.15,3,3,0,0,0,1.06-.72,6.77,6.77,0,0,0,1.75-3.79,20.16,20.16,0,0,0,0-4.23,2.39,2.39,0,0,0-.16-.85,2.19,2.19,0,0,0-.55-.68A12.8,12.8,0,0,0,186.7,41a2.71,2.71,0,0,1-1-.76,2.44,2.44,0,0,1-.31-.9L185.14,38a2.61,2.61,0,0,0-.38-1.08,2.65,2.65,0,0,0-2.11-.74l-2.83-.11a13.63,13.63,0,0,0-2.9-.11c-.8.16-.54.9-.39,1.57A11.37,11.37,0,0,1,176.9,40Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9,40c-.15,1.32-1.15,2.38-1.52,3.65-.56,1.91.41,4,1.73,5.46a12.08,12.08,0,0,0,8.41,4,3.59,3.59,0,0,0,1.39-.15,3,3,0,0,0,1.06-.72,6.77,6.77,0,0,0,1.75-3.79,20.16,20.16,0,0,0,0-4.23,2.39,2.39,0,0,0-.16-.85,2.19,2.19,0,0,0-.55-.68A12.8,12.8,0,0,0,186.7,41a2.71,2.71,0,0,1-1-.76,2.44,2.44,0,0,1-.31-.9L185.14,38a2.61,2.61,0,0,0-.38-1.08,2.65,2.65,0,0,0-2.11-.74l-2.83-.11a13.63,13.63,0,0,0-2.9-.11c-.8.16-.54.9-.39,1.57A11.37,11.37,0,0,1,176.9,40Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.88,99.24l-1.2,13.18c-.31,3.46-.63,6.93-1.25,10.34-.21,1.18-.46,2.35-.76,3.5-.82,3.22-2,6.37-2.4,9.67,0,.1,0,.19,0,.29a8.4,8.4,0,0,1-.41,2.14c-.19.5-.49,1-.7,1.46a9.32,9.32,0,0,0-.52,3.17,13.69,13.69,0,0,0-4.71-1.61,3.6,3.6,0,0,1-2.23-.8,3.19,3.19,0,0,1-.44-2.56l1-8.25a21.51,21.51,0,0,1,.6-3.5c.11-.38.24-.76.37-1.14s.37-1,.51-1.57a18.87,18.87,0,0,0,.42-2.61c.33-2.77.72-5.53,1.06-8.3l0-.15a84.83,84.83,0,0,0,.8-12.63c0-.63,0-1.25-.08-1.88-.06-.91-.14-1.39.61-2a14.16,14.16,0,0,1,2.88-1.48c.51-.22,6.15-2.22,6.28-1.78a11,11,0,0,1,.41,2.88A32,32,0,0,1,194.88,99.24Z",
    style: {
      fill: "#605d82"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.43,122.75c-.21,1.18-.46,2.35-.76,3.5-.82,3.22-2,6.37-2.4,9.67,0,.1,0,.19,0,.29-2.51-3.59-4.63-7.45-7.08-11.08.18-.52.37-1,.51-1.57a18.89,18.89,0,0,0,.42-2.61c.33-2.77.72-5.53,1.06-8.3l0-.15a8.6,8.6,0,0,0,.61,1.7c1.65,3.35,5.56,5,7.47,8.24Z",
    style: {
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,93.33a62.27,62.27,0,0,0,.94,8l.88,5.47a28,28,0,0,0,2.4,8.73,40.42,40.42,0,0,0,4,5.52c3.4,4.42,5.95,9.44,9.17,14,.94,1.32,2.27,2.75,3.87,2.48a6.29,6.29,0,0,0,2.63-1.73,16.4,16.4,0,0,0,2.91-2.37c.76-1,.91-2.65-.12-3.35a5.46,5.46,0,0,0-1.19-.49,6.43,6.43,0,0,1-3.31-3.76,36,36,0,0,0-1.94-4.76c-1.91-3.2-5.83-4.89-7.48-8.24a14.88,14.88,0,0,1-1.08-6.12l-.18-5.32a3.89,3.89,0,0,1,.2-1.72c.63-1.42,2.53-1.55,4.07-1.73a13.93,13.93,0,0,0,5-1.57,5.21,5.21,0,0,0,2.23-2,6.38,6.38,0,0,0,.54-2.68L196.1,82a6,6,0,0,0-.2-2.47c-.73-2-3.2-2.59-5.29-2.5-3.88.17-7.46,1.84-11.12,3a28.29,28.29,0,0,1-2.76.72,22.17,22.17,0,0,0-2.6.36c-1.39.47-1.36,3.52-1.56,4.78A40.24,40.24,0,0,0,172,93.33Z",
    style: {
      fill: "#605d82"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.75,137.91a2.47,2.47,0,0,1,.54,1.33,45.38,45.38,0,0,1,.77,8,1.31,1.31,0,0,0,.14.73.91.91,0,0,0,.38.3c1,.47,2.14-.19,3-.91a7.64,7.64,0,0,0,2.91-5.16,12,12,0,0,1,.05-1.57,6.54,6.54,0,0,1,1-2.1,17.71,17.71,0,0,0,1.61-3.61c.15-.47.25-1.07-.12-1.4a1.35,1.35,0,0,0-.44-.23l-4.47-1.66c-.39-.14-1.35,2.33-1.5,2.6a2,2,0,0,1-1.5,1.19c-.77.16-1.68-.07-2.39.31C191.46,136.43,192.07,137.22,192.75,137.91Z",
    style: {
      fill: "#535070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.86,139.43a1.37,1.37,0,0,0-.34-.43,1.54,1.54,0,0,0-.69-.23,2.68,2.68,0,0,0-2.45.39c-.55.59-.46,1.56-.92,2.22-.15.21-.34.38-.47.61a2.29,2.29,0,0,0-.21,1.09c0,1,0,2.06,0,3.09a4.33,4.33,0,0,0,.74,2.44c.87,1.08,2.43,1.24,3.81,1.31l1.12.06a2.19,2.19,0,0,0,.92-.08,1.51,1.51,0,0,0,.79-.87c.58-1.45-.34-3-.91-4.47C186.64,142.88,186.76,141,185.86,139.43Z",
    style: {
      fill: "#535070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.57,32.59a.93.93,0,0,1,.06-.43c.16-.29.59-.21.92-.13a21.34,21.34,0,0,0,4,.11c1.34.08,2.85.75,3.12,2.06a9.79,9.79,0,0,0,2.47-2.54,3.05,3.05,0,0,0,.65-1.86,3.64,3.64,0,0,0-1.63-2.29l-2.23-1.82a3.36,3.36,0,0,0-1-.63,5,5,0,0,0-1.62-.09c-1.62,0-3.35-.74-4.8,0A5.18,5.18,0,0,0,175,26.31l-2,2.36a1.26,1.26,0,0,0-.32.54,2.39,2.39,0,0,0,.14.86c.09.53-.13,1.09,0,1.59.29.84,1.31,1,1.93,1.44.23.18.6.79.87.78C176.21,33.87,176.56,33,176.57,32.59Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.95,
    cy: 33.16,
    r: 6.37,
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.44,47.11a3.09,3.09,0,0,0-3-2.07.92.92,0,0,1-.55-.07.76.76,0,0,1-.23-.28,11.14,11.14,0,0,1-.93-2.2c-.1-.34-.24-.73-.58-.82a.79.79,0,0,0-.74.32,6.54,6.54,0,0,1-.53.67c-.8.72-2.22.06-3.07.72-.14.11-.25.24-.4.34a1.87,1.87,0,0,1-.47.2,44.89,44.89,0,0,0-4.82,1.89,45.44,45.44,0,0,0,2.47,10.07c.63,1.52,1.35,3,1.85,4.57,1.12,3.47,1.17,7.18,1.18,10.82a22.54,22.54,0,0,1-.81,7.4,7,7,0,0,0-.46,1.63,1.68,1.68,0,0,0,.57,1.52,2,2,0,0,0,.88.31,11.4,11.4,0,0,0,4.18-.49c3.69-.85,7.45-1.34,11.21-1.83l6.29-.82a3.65,3.65,0,0,0,1.3-.34c1.15-.63,1.26-2.36.55-3.46a18.81,18.81,0,0,1-1.11-1.52,1.41,1.41,0,0,1,.18-1.73c1-.79.71-2.25.76-3.53q.2-5.37-.05-10.73a21.39,21.39,0,0,1,0-2.23,19.72,19.72,0,0,1,.69-3.71l1.91-7.53a3.92,3.92,0,0,0-2.36-1.52c-.91-.23-1.85-.29-2.74-.57-1.83-.57-3.45-2-5.36-1.87a1,1,0,0,0-.42.1c-.43.24-.36.86-.39,1.36a3.75,3.75,0,0,1-1.75,2.65,31.19,31.19,0,0,0-2.72,1.84A1.21,1.21,0,0,0,181.44,47.11Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.19,54.25a7.52,7.52,0,0,1-1.34.69,4.4,4.4,0,0,0-1.28.62,2,2,0,0,0-.45.55,2.45,2.45,0,0,0,2.26,3.66,4.93,4.93,0,0,0,1.67-.5l4.5-1.95a3.54,3.54,0,0,0,1.94-1.46.34.34,0,0,0,0-.23.38.38,0,0,0-.18-.19A10,10,0,0,1,160.73,53c-.18-.25-.41-.84-.67-1C159.11,51.42,156.95,53.75,156.19,54.25Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.24,52.65l1.66,1.89c.36.41.71.81,1,1.25a14.53,14.53,0,0,1,1.9,3.58,6.24,6.24,0,0,1,.53,3,7.23,7.23,0,0,1-.41,1.5,18.72,18.72,0,0,1-1.13,2.71,15.45,15.45,0,0,1-1.27,1.9,44.34,44.34,0,0,1-4.2,4.81,5.48,5.48,0,0,0-1.05,2.23A9.3,9.3,0,0,1,198.72,79a7.18,7.18,0,0,1-1.11,1,3.61,3.61,0,0,1-2,.58,2.22,2.22,0,0,1-.91-.19,2.35,2.35,0,0,1-1.16-2,4.17,4.17,0,0,1,.35-2.09c1-2.11,3.39-3,5.12-4.56a16.63,16.63,0,0,0,2.55-3.15,10.9,10.9,0,0,0,1.29-2.26c.39-1,.24-2.25.57-3.29.14-.44.4-.84.55-1.28a1.49,1.49,0,0,0-.08-1.34,2,2,0,0,0-.75-.55c-1.1-.56-2.34-1.28-2.55-2.5a2.68,2.68,0,0,1,.49-1.91A8,8,0,0,1,202.47,54C203,53.56,203.76,53.08,204.24,52.65Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.12,56.89a3.08,3.08,0,0,0-1.25-1.49,2.3,2.3,0,0,0-1.82,0,6.83,6.83,0,0,0-1.59,1L149,57.41a3.52,3.52,0,0,0-.85.78,3.3,3.3,0,0,0-.44,1.21,8.66,8.66,0,0,0-.22,3,8.52,8.52,0,0,0,2.27,4.24,3.77,3.77,0,0,0,2.51,1.57,1.15,1.15,0,0,0,1.11-.56,1.39,1.39,0,0,0,.1-.5A11.08,11.08,0,0,0,152.22,62a3.33,3.33,0,0,1-.41-1.39.38.38,0,0,1,.06-.23.39.39,0,0,1,.24-.12c1-.2,2.79.59,3.51-.55C156.09,58.95,155.45,57.56,155.12,56.89Z",
    style: {
      fill: "#a0616a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.24,30.58a.93.93,0,0,1,.06-.43c.16-.29.59-.21.92-.13a21.34,21.34,0,0,0,4,.11c1.34.08,2.85.75,3.12,2.06a9.79,9.79,0,0,0,2.47-2.54,3.05,3.05,0,0,0,.65-1.86,3.64,3.64,0,0,0-1.63-2.29l-2.23-1.82a3.36,3.36,0,0,0-1-.63,5,5,0,0,0-1.62-.09c-1.62,0-3.35-.74-4.8,0a5.18,5.18,0,0,0-1.49,1.36l-2,2.36a1.26,1.26,0,0,0-.32.54,2.4,2.4,0,0,0,.14.86c.09.53-.13,1.09,0,1.59.29.84,1.31,1,1.93,1.44.23.18.6.79.87.78C175.88,31.86,176.22,31,176.24,30.58Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.7,48a2.59,2.59,0,0,0-.67.62c-.23.35-.28.8-.48,1.17-.43.8-1.43,1.08-2.06,1.74a.65.65,0,0,0-.2.34.76.76,0,0,0,.17.49l3,4.75c1,.09,2-.54,3-.46a3,3,0,0,0,1.12,0,3.21,3.21,0,0,0,.72-.44c.6-.38,1.4-.42,1.9-.93a2.61,2.61,0,0,0,.54-1.92,7.7,7.7,0,0,0-.18-1.76c-.44-1.82-1.84-3.22-2.71-4.84-.43-.79-.66-1.25-1.56-.71S163.55,47.42,162.7,48Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.4,45.65A7.07,7.07,0,0,1,200.93,47c.46.59.72,1.32,1.16,1.93a21.51,21.51,0,0,0,1.5,1.59,12.25,12.25,0,0,1,1.73,2.81,42,42,0,0,1-3.91,4.42,1.26,1.26,0,0,1-.59.39,1,1,0,0,1-.84-.34c-.22-.23-.37-.51-.58-.75a3,3,0,0,0-1.85-.89,12.68,12.68,0,0,0-2.09,0A.83.83,0,0,1,195,56a.75.75,0,0,1-.24-.28c-.82-1.39-.56-3.14-.27-4.73l.66-3.65a8.18,8.18,0,0,1,.55-2c.25-.54.81-1.45,1.5-1.29S198.82,45.22,199.4,45.65Z",
    style: {
      fill: "#3f3d56"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.15,
    cy: 59.49,
    rx: 10.08,
    ry: 10.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.15,47.68a12,12,0,1,0,12,12A12,12,0,0,0,78.15,47.68Zm6,16-2,2-4-4-4,4-2-2,4-4-4-4,2-2,4,4,4-4,2,2-4,4Z",
    style: {
      fill: "#57b894"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailUnsubscribe);
export default __webpack_public_path__ + "static/media/email-unsubscribe.3ec6a24cc1adfc36571681f3875f0edd.svg";
export { ForwardRef as ReactComponent };